import { useEffect, useState } from "react";
import { Countdown } from "../types";
import { now } from "../time";

export function useCountdown(countdown: Countdown) {
  const [timeRemaining, setTimeRemaining] = useState(
    now() - countdown.deadline
  );

  useEffect(() => {
    if (countdown) {
      const interval = setInterval(() => {
        setTimeRemaining(now() - countdown.deadline);
      }, 500);

      return () => {
        clearInterval(interval);
      };
    }
  }, [countdown]);

  return timeRemaining;
}
